var _learnq = _learnq || [];

function addedToCart(item) {
  var cart = {
    total_price: item.price / 100,
    $value: item.price / 100,
    total_discount: 0,
    original_total_price: item.price / 100,
    items: [{
      id: item.variant_id,
      quantity: item.quantity,
      product_id: item.product_id,
      sku: item.sku,
      name: item.title,
      price: item.price / 100,
      rowTotal: item.price / 100,
      url: window.location.origin + item.url,
      imageURL: "https:" + item.image,
      productType: item.product_type,
      vendor: item.vendor,
    }]
  };
  _learnq.push(['track', 'Added to Cart', cart]);
}

document.addEventListener('click', function(e) {
  var btn = e.target.closest('form[action="/cart/add"] button[type="submit"], button[name="add"]');
  if (!btn) return;
  var form = btn.closest('form');
  if (!form) return;

  setTimeout(function() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(function(cart) {
        if (cart.items && cart.items.length > 0) {
          addedToCart(cart.items[0]);
        }
      });
  }, 500);
});